import { createSelector } from 'reselect'
import getSelectedSubscriptionSellingPlanByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-selected-subscription-plan-by-id'
import getRecurrenceLabelFromPlanNameSubscriptionUtil from 'modules/subscription/utils/get-recurrence-label-from-plan-name'

/**
 * @param props
 * @param props.variantId
 * @param props.isShort
 */
const getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector = ({
  variantId,
  isShort
}) => createSelector(
  getSelectedSubscriptionSellingPlanByIdVariantSelector(variantId),
  /**
   * @param {VariantSellingPlan} sellingPlan
   * @return {VariantSellingPlan}
   */
  (sellingPlan) => {
    return getRecurrenceLabelFromPlanNameSubscriptionUtil({
      name: sellingPlan?.name,
      shouldIgnoreMostCommon: true,
      isShort
    })
  }
)

export default getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector
